import type { ModuleNav } from '@saas/ui';

/** 自分の日報を書く・読む */
export const REPORT_OWN_PERMISSIONS = ['report.report.write.own', 'report.report.read.own', 'report.report.read.team', 'report.report.read.all'];
/** 部下（team）/ 全員（all）の日報 */
export const REPORT_TEAM_PERMISSIONS = ['report.report.read.team', 'report.report.read.all'];
export const REPORT_SUMMARY_PERMISSIONS = ['report.summary.read'];

/** apps/web のシェルが集約する。登録はリードが行う（apps/web/src/app/shell/nav.ts） */
export const reportNav: ModuleNav = {
  module: 'report',
  items: [
    { label: '今日の日報', to: '/report', icon: 'assignment', end: true, permission: REPORT_OWN_PERMISSIONS, description: '自動で入ったものを確かめて、2 つの欄を書いて提出する' },
    { label: '日報の履歴', to: '/report/history', icon: 'history', permission: REPORT_OWN_PERMISSIONS, description: '自分の日報を日付で振り返る' },
    { label: '部下の日報', to: '/report/team', icon: 'group', permission: REPORT_TEAM_PERMISSIONS, description: '今日の提出状況と中身' },
    { label: '期間集計', to: '/report/summary', icon: 'bar_chart', permission: REPORT_SUMMARY_PERMISSIONS, description: '週・月の「わかったこと」「詰まったこと」と自動項目の集計' },
  ],
  admin: [],
};
